import { render, staticRenderFns } from "./AccountSettingDeleteAccount.vue?vue&type=template&id=71214895&scoped=true&"
import script from "./AccountSettingDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./AccountSettingDeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingDeleteAccount.vue?vue&type=style&index=0&id=71214895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71214895",
  null
  
)

export default component.exports